module.exports = __webpack_public_path__ + "static/media/loupe.51090911.svg";